import React, { useEffect, useState } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";

const Dashboard = () => {
    const [stats, setStats] = useState({});
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await axios.get("http://127.0.0.1:8000/dashboard-stats");
                setStats(response.data);
            } catch (err) {
                console.error("Error fetching dashboard stats:", err);
                setError("Failed to fetch dashboard stats");
            }
        };

        fetchStats();
    }, []);

    const data = {
        labels: ["Total Blobs", "TX Blobs", "NFT Blobs", "ZK Rollup TX", "IBC Blobs"],
        datasets: [
            {
                data: [
                    stats.totalBlobs || 0,
                    stats.txBlobs || 0,
                    stats.nftBlobs || 0,
                    stats.zkRollupTx || 0,
                    stats.ibcBlobs || 0
                ],
                backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"],
                hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"]
            }
        ]
    };

    return (
        <div className="dashboard-container">
            <header>
                <h1>Dashboard</h1>
            </header>
            {error && <p className="error">{error}</p>}
            <div className="stats">
                <Doughnut data={data} />
            </div>
        </div>
    );
};

export default Dashboard;